/**
 * Proposals page — commercial proposals (extends quotes with title/description).
 * Reuses quotes infrastructure with proposal-specific labels.
 */
import QuotesPage from './QuotesPage';

const ProposalsPage = () => <QuotesPage proposalMode />;

export default ProposalsPage;
